'use client';

import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

/**
 * Defer Sonner mount until after the first client commit.
 *
 * Phase 1 SAH go-live: mounting `<Toaster>` in the root layout during the
 * insertion-effect phase (alongside @dnd-kit / preference hydration) was
 * scheduling React updates and tripping `useInsertionEffect must not schedule
 * updates` on every dashboard route. A one-tick deferral keeps toast delivery
 * unchanged while letting the shell settle first.
 */
export function AppToaster() {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  return (
    <Toaster
      position="bottom-right"
      // Sonner has one global duration; warning/error persistence and contextual
      // actions must be supplied by the toast producer, outside this styling lane.
      duration={5000}
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-center gap-3 rounded-overlay border border-border bg-surface-sheet p-4 font-body text-body-sm text-text-body shadow-popover',
          title: 'font-semibold',
          description: 'text-body-sm text-text-muted',
          success: 'bg-status-success-bg text-status-success-fg border-status-success-border',
          info: 'bg-status-information-bg text-status-information-fg border-status-information-border',
          warning: 'bg-status-warning-bg text-status-warning-fg border-status-warning-border',
          error: 'bg-status-danger-bg text-status-danger-fg border-status-danger-border',
          actionButton:
            'ml-auto min-h-control rounded-control bg-action px-3 text-action-foreground hover:bg-action-hover focus-visible:ring-2 focus-visible:ring-focus',
          closeButton:
            'rounded-control border border-control-border bg-surface-sheet text-text-body focus-visible:ring-2 focus-visible:ring-focus',
        },
        style: {
          fontFamily: 'var(--font-space-grotesk)',
        },
      }}
    />
  );
}
